import React from 'react';

/**
 * Required attribution when the floating reCAPTCHA badge is hidden.
 * See https://developers.google.com/recaptcha/docs/faq
 */
const RecaptchaNotice = ({ className = '' }) => (
    <p className={`text-xs text-gray-400 text-center ${className}`}>
        Protected by reCAPTCHA. Google's{' '}
        <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-gray-600"
        >
            Privacy Policy
        </a>{' '}
        and{' '}
        <a
            href="https://policies.google.com/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-gray-600"
        >
            Terms of Service
        </a>{' '}
        apply.
    </p>
);

export default RecaptchaNotice;
